// extracted by mini-css-extract-plugin
export default {"wrap":"RiskEdit_wrap__dPhlj","row":"RiskEdit_row__FuFw8"};